import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themes } from 'contexts/theme-context'
import { Link } from 'atoms'
import Clock from 'images/icons/Clock'

const NotificationWrapper = styled.div`
  padding: 12px 24px;
  display: flex;
  color: ${(p) => (p.read ? '#b2babd' : '#384047')};
  flex-flow: row nowrap;
  font-weight: ${(p) => (p.read ? '400' : '700')};

  svg {
    path {
      fill: ${(p) => (p.read ? '#b2babd' : '#384047')} !important;
    }
  }
`

const Timestamp = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #b2babd;
  margin: 4px 0 0;

  svg {
    path {
      fill: #b2babd !important;
    }
  }
`

const ShieldWrapper = styled.div`
  width: 40px;
  height: 40px;
  margin: 0 16px 0 0;
`

const MessageWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
`

const LinkWrapper = styled(Link)`
  display: flex;

  &:not(:last-child) {
    border-bottom: 1px solid #e2e2e2;
  }

  &:hover {
    background-color: #edeef0;
  }
`

function Notification(props) {
  const { notification } = props
  const themeKey = Object.keys(themes).find((themeKey) => {
    return themes[themeKey].clientId.toUpperCase() === notification.message.brand.toUpperCase()
  })

  const theme = themes[themeKey]

  if (!theme) {
    return null
  }

  let notificationHref = null
  if (notification.message.url) {
    notificationHref =
      notification.message.url.substring(0, 1) === '/'
        ? `${theme.siteUrl}${notification.message.url}`
        : notification.message.url
  }

  const publishedAtDate = new Date(notification.publishedAt)

  return (
    <LinkWrapper href={notificationHref || Link.noopHref}>
      <NotificationWrapper read={!!notification.readAt}>
        <ShieldWrapper>{theme.shield}</ShieldWrapper>
        <MessageWrapper>
          <div dangerouslySetInnerHTML={{ __html: notification.message.payload }} />
          <Timestamp>
            <Clock />
            {publishedAtDate.toLocaleDateString()} {publishedAtDate.toLocaleTimeString()}
          </Timestamp>
        </MessageWrapper>
      </NotificationWrapper>
    </LinkWrapper>
  )
}

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
}

export default Notification



// WEBPACK FOOTER //
// ./src/molecules/NotificationsBell/components/Notification.js